import Loadable from '../../components/loadable';

const MobileAppUsersReport = Loadable({
  loader: () => import('../../pages/reports/mobile_app_users_report/mobile_app_users_report'),
});

angular.module('gym').value('MobileAppUsersReport', MobileAppUsersReport);

const MobileAppUsersReportFiltersModal = Loadable({
  loader: () =>
    import('../../pages/reports/mobile_app_users_report/mobile_app_users_report_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('MobileAppUsersReportFiltersModal', MobileAppUsersReportFiltersModal);
